import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { RollFromLeft } from "../ui/animations";

const NavigationList = styled.ul`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style-type: none;
  z-index: 10;
  margin-top: 5vh;
`;

const NavigationLink = styled.li`
  text-transform: uppercase;
  min-width: calc(100vw / 6);
  color: inherit;
  font-size: 17px;
  font-weight: bold;
  letter-spacing: 0.47em;
  text-decoration: none;
  overflow-x: hidden;
  animation: ${RollFromLeft} 1.75s ease;
  z-index: 10;
  padding-bottom: 6px;
  position: relative;
  &:after {
    content: '';

    width: ${p => p.uLineW || "100%"};
    position: absolute;
    left: 0px;
    bottom: 0px;

    border-width: 0 0 2px 0;
    border-style: solid;
    border-color: white;
  }
  @media screen and (max-width: 768px) {
    min-width: calc(100vw / 3);
  }
  @media screen and (max-width: 400px) {
    font-size: 13px;
    &:after {
      transform: scaleX(0.75);
      transform-origin: left;
    }
  }
`;

export default class Navigation extends Component {
  static propTypes = {
    links: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired
      })
    )
  };

  static defaultProps = {
    links: [
      { text: "Example link 1", path: "/example1" },
      { text: "Example link 2", path: "/example2" }
    ]
  };

  render() {
    const { links } = this.props;
    return (
      <nav>
        <NavigationList>
          {links.map(({ text, path, uLineW }) => (
            <NavigationLink key={path} as={Link} to={path} uLineW={uLineW} >
              {text}
            </NavigationLink>
          ))}
        </NavigationList>
      </nav>
    );
  }
}
